import { TagBadge, Tag } from './TagBadge';

interface InvoiceTagsProps {
  invoiceId: string;
  tags?: Tag[];
}

/**
 * Display tags for an invoice (read-only for table view)
 *
 * Tags can be passed as props for bulk-loaded scenarios (e.g., invoice list)
 * to avoid N+1 query problems.
 */
export function InvoiceTags({ invoiceId, tags = [] }: InvoiceTagsProps) {
  if (tags.length === 0) {
    return <div className="text-xs text-muted-foreground">-</div>;
  }

  return (
    <div className="flex flex-wrap gap-1">
      {tags.map((tag) => (
        <TagBadge key={tag.id} tag={tag} size="xs" />
      ))}
    </div>
  );
}
